import { queryOptions } from "@tanstack/react-query";
import { getNewsComments, createNewsComment } from "@/lib/api/generated/endpoints/news/news";
import type { CreateNewsCommentRequest, NewsCommentItem } from "@/lib/api/generated/model";

export const NEWS_COMMENT_SORT_MODES = ["recommended", "newest", "oldest"] as const;
export type NewsCommentSortMode = (typeof NEWS_COMMENT_SORT_MODES)[number];
export type { NewsCommentItem, CreateNewsCommentRequest };

export function newsCommentsQueryOptions(
  articleId: string,
  sortMode: NewsCommentSortMode = "recommended",
) {
  return queryOptions({
    queryKey: ["news-comments", articleId, sortMode],
    queryFn: () => getNewsComments({ articleId, sortMode }),
    staleTime: 1000 * 30,
  });
}

export function createNewsCommentAction(input: CreateNewsCommentRequest) {
  return createNewsComment(input);
}
